import _ from 'lodash';
import { renderApp } from '..';
import { HEADER } from '_constants';
import { push, goBack } from 'connected-react-router';
import Cookies from 'js-cookie'; 

export const refreshApp = () => renderApp();

export const redirectToRoute = (pathname, headerOptions, routerState = {}) => (dispatch, getState) => {
  const prevPath = getState().router.location.pathname;
  const userprofile = getState().userprofile;

  if (pathname != "/" && (_.isEmpty(userprofile) || typeof (userprofile) === "undefined" || userprofile === null)) {
    localStorage.setItem('notificationRoute', pathname);
  }

  if (prevPath === pathname) {
    return;
  }
  if (headerOptions) { dispatch({ type: HEADER.UPDATE_HEADER, ...headerOptions }); }
  if (pathname === 'goback') { return dispatch(goBack()); }
  return dispatch(push({ pathname: pathname || '/', state: { ...routerState } }));
};

export const saveCookie = (key, value) => {
  Cookies.set(key, value, { path: '/' });
};

export const removeCookie = (key) => {
  Cookies.remove(key, { path: '/' });
};
